import { Link } from "react-router-dom";

const LOGO_SRC = "/brand/joyn-logo.png";
const LOGO_WHITE = "/brand/joyn-logo-white.png";

/* The official joyn logo, used as-is. */
export default function Logo({ className = "", dark = false, height = 44 }) {
  return (
    <Link to="/" data-testid="brand-logo" className={`inline-flex items-center ${className}`} aria-label="joyn home">
      <img src={dark ? LOGO_WHITE : LOGO_SRC} alt="joyn" style={{ height }} className="w-auto" />
    </Link>
  );
}

/* Decorative brand mark = the official logo image (white variant for dark sections). */
export function JoynMark({ size = 44, className = "", onDark = false }) {
  return (
    <span className={`inline-flex ${className}`}>
      <img src={onDark ? LOGO_WHITE : LOGO_SRC} alt="joyn" style={{ height: size }} className="w-auto" />
    </span>
  );
}
